import bgHome from 'static/mb32/bg-home.png';
import bgHomeNew from 'static/mb32/bg-home-new.png';
import bgEmpty from 'static/mb32/bg-empty.png';
import bgLoading from 'static/mb32/bg-loading.webp';
import bgModal from 'static/mb32/bg-modal.png';
import bgReelAqua from 'static/mb32/bg-reel-aqua.webp';
import bgReelBlue from 'static/mb32/bg-reel-blue.webp';
import bgReelOrange from 'static/mb32/bg-reel-orange.webp';
import bgReelPink from 'static/mb32/bg-reel-pink.webp';
import bgReelPurple from 'static/mb32/bg-reel-purple.webp';
import bgRodal from 'static/mb32/bg-rodal.png';
import bgSurfaceReel from 'static/mb32/bg-surface-reel.png';
import bgToolbar from 'static/mb32/bg-toolbar.png';
import icLosing from 'static/mb32/ic-losing 2.png';
import icMoney from 'static/mb32/ic-money.png';
import icMoneyRank from 'static/mb32/ic-money-rank.png';
import imgQuayOng from 'static/mb32/img-quayOng-new.png';
import prizeMoney from 'static/mb32/prize-money.png';
import rollImage from 'static/mb32/roll_image.png';
import { GAME_CODE_THEME_NEW } from "helpers/constants";

const MB32_ASSETS = {
  'bg-home': bgHome,
  'bg-home-new': bgHomeNew,
  'bg-empty': bgEmpty,
  'bg-loading': bgLoading,
  'bg-modal': bgModal,
  'bg-reel-aqua': bgReelAqua,
  'bg-reel-blue': bgReelBlue,
  'bg-reel-orange': bgReelOrange,
  'bg-reel-pink': bgReelPink,
  'bg-reel-purple': bgReelPurple,
  'bg-rodal': bgRodal,
  'bg-surface-reel': bgSurfaceReel,
  'bg-toolbar': bgToolbar,
  'ic-losing': icLosing,
  'ic-money': icMoney,
  'ic-money-rank': icMoneyRank,
  'img-quayOng-new': imgQuayOng,
  'prize-money': prizeMoney,
  'roll_image': rollImage,
};

export const getGameAsset = (gameCode, assetName, fallback) => {
  if (!GAME_CODE_THEME_NEW.includes(gameCode)) {
    return fallback;
  }

  return MB32_ASSETS[assetName] || fallback;
};
